import React, { useCallback, useMemo, useState } from 'react';
import { IdPropType } from '../../../proptypes/basic';
import TitleBar from '../../layout/components/TitleBar';
import ResourceTable from '../../table/components/resource/ResourceTable';
import {AGENCY_RESOURCE } from '../../api/resources';
import Agency from '../../agencies/components/Agency';
import LocationAgencyDatevId from '../components/LocationAgencyDatevId';
import { useDialog } from '../../dialogs/components/DialogContext';
import { selectLocationById } from '../locationsSlice';
import { useSelector } from 'react-redux';
const LocationAgencies = ({ locationId }) => {
    // get all locations
    
    const listId = `Agencies`;
    const { openLocationAgencyDialog } = useDialog();
    const [reloadKey, setReloadKey] = useState(0);
    const location = useSelector((state) => selectLocationById(state, locationId));
    const initialOrderBy = [['matchCode', 'asc']];

    const onClose = useCallback((sender) => {
        setReloadKey(prev => prev + 1);
    }, []);


    const handleEdit = async (agencyId) =>{

        try {
            await openLocationAgencyDialog({ locationId, agencyId, onDone: onClose });
        } catch (err) {
            //setErrorLoadingExportData(err);
        } finally {
            //setReloadKey(prev => prev + 1);
        }
    };

     const columns = useMemo(() => [
        {
            key: 'id',
            as: 'agencyId',
            label: 'Agentur',
            component: ({ agencyId }) => <Agency agencyId={agencyId} withoutFallback />,
            sortable: false,
        },
        {
            key: 'locationAgencies',
            label: 'Datev-ID',
            component: ({ locationAgencies, data }) => {
                const agencyEntry = Array.isArray(locationAgencies)
                    ? locationAgencies.find(la => String(la.locationId) === String(locationId))
                    : null;
                return (
                    !agencyEntry || !agencyEntry.agencyDatevId ? '-' :
                    <LocationAgencyDatevId
                        agency_datev_id={agencyEntry.agencyDatevId}
                        withoutFallback
                    />
                );
            },
            sortable: false,
        },
    ], [locationId]);

    // only active agencies
    const fetchParams = useMemo(() => ({ isActive: true }), []);

    return (
        <>
            <TitleBar>
                Agenturen im Auftrag des Standortes '{location.name}'
            </TitleBar>

            <ResourceTable
                key={reloadKey}
                columns={columns}
                resource={AGENCY_RESOURCE}
                listId={listId}
                onEdit={handleEdit}
                autoload
                refresh={true}
                fetchParams={fetchParams}
                initialOrderBy={initialOrderBy}

            />
        </>
    );
};

LocationAgencies.propTypes = {
    locationId: IdPropType.isRequired,
};

LocationAgencies.defaultProps = {};

export default LocationAgencies;
